import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/genericPlayer.png'


const _withScopeId = n => (_pushScopeId("data-v-5b419a82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "paymentWrapper" }
const _hoisted_3 = { class: "wrapperCheckout flex justify-around sm:flex-col" }
const _hoisted_4 = { class: "paymentBoxRight md:p-6 sm:pt-4 md:mr-6 sm:mb-6 relative" }
const _hoisted_5 = { class: "sm:hidden" }
const _hoisted_6 = { class: "backgroundPayment md:mt-8 sm:pb-7" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = {
  key: 0,
  class: "check paySelected mr-6 relative"
}
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = {
  key: 0,
  class: "w-full"
}
const _hoisted_11 = { class: "mb-2 text-xl sm:text-sm" }
const _hoisted_12 = { class: "text-sm playerSubtitle pr-2 sm:text-xs sm:mb-2" }
const _hoisted_13 = { class: "text-white" }
const _hoisted_14 = {
  key: 1,
  class: "w-full"
}
const _hoisted_15 = { class: "mb-2 text-xl sm:text-sm" }
const _hoisted_16 = { class: "sm:flex mr-4" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "customBorder addPlayers sm:p-1 p-3 flex justify-center sm:absolute overflow-hidden break-words items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "playerIcon pb-4 relative" }, null, -1))
const _hoisted_20 = {
  key: 0,
  class: "text-sm text-center sm:text-xs"
}
const _hoisted_21 = {
  key: 1,
  class: "text-sm text-center sm:text-xs"
}
const _hoisted_22 = {
  key: 2,
  class: "text-sm text-center sm:text-xs"
}
const _hoisted_23 = {
  key: 1,
  class: "containerPayPlayers"
}
const _hoisted_24 = {
  key: 0,
  class: "checkoutPlayers w-full mt-4 p-2"
}
const _hoisted_25 = { class: "flex items-center justify-between" }
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = { class: "flex items-center sm:justify-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sm:w-8 sm:h-8 mr-3 md:w-12",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_29 = { class: "mr-2" }
const _hoisted_30 = { class: "playerSubtitle sm:text-xs" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { class: "flex items-center justify-between" }
const _hoisted_33 = { class: "flex items-center" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sm:w-8 sm:h-8 mr-3 md:w-12",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_35 = { class: "playerSubtitle sm:text-xs" }
const _hoisted_36 = {
  key: 0,
  class: "playerSubtitle sm:text-xs"
}
const _hoisted_37 = { class: "flex items-center" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check paySelected mr-6 relative" }, null, -1))
const _hoisted_39 = { class: "flex flex-col" }
const _hoisted_40 = { class: "flex-col w-full" }
const _hoisted_41 = { class: "mb-2 text-xl sm:text-sm" }
const _hoisted_42 = { class: "text-sm playerSubtitle pr-2 sm:text-xs sm:mb-2" }
const _hoisted_43 = { class: "text-white" }
const _hoisted_44 = { class: "flex" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "text-lg sm:text-lg" }
const _hoisted_49 = { class: "flex items-center" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check paySelected mr-6 relative sm:mt-6" }, null, -1))
const _hoisted_51 = { class: "mb-2 text-xl sm:text-sm" }
const _hoisted_52 = {
  key: 4,
  class: "bottomTotal flex flex-col pb-4 p-4"
}
const _hoisted_53 = {
  key: 0,
  class: "flex items-center bg-blue-500 text-white text-xs px-4 py-3 mt-2",
  role: "alert",
  style: {"border-radius":"28px"}
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-current w-6 h-6 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" })
], -1))
const _hoisted_55 = { style: {"white-space":"pre-line"} }
const _hoisted_56 = { class: "flex flex-row items-center justify-between w-full mt-6" }
const _hoisted_57 = { class: "text-xl sm:text-sm flex-shrink-0" }
const _hoisted_58 = { class: "flex-1 text-right mx-4" }
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = {
  key: 0,
  class: "customBorder addPlayers p-3 flex justify-center overflow-hidden break-words items-center flex-shrink-0"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "playerIcon pb-4 relative" }, null, -1))
const _hoisted_62 = { class: "text-sm text-center sm:text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BookingDetail = _resolveComponent("BookingDetail")!
  const _directive_disable_on_click = _resolveDirective("disable-on-click")!

  return (_ctx.booking !== null)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_BookingDetail, {
              booking: _ctx.booking,
              showShare: false,
              showOpenFacility: false,
              showResourceName: true,
              class: "paymentBoxLeft p-6 pt-8 md:mr-6"
            }, null, 8, ["booking"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.isMatch
                ? _ctx.$t('checkout').toUpperCase()
                : _ctx.booking?.hidePaymentMethods
                  ? _ctx.$t('proceed_to_payment').toUpperCase()
                  : _ctx.$t('pay_mode').toUpperCase()), 1),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.showShared)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass([{ customBorder: _ctx.fullPayment === false }, "paymentOption cursor-pointer flex items-center flex-row p-6 justify-between sm:flex-col sm:justify sm:relative"]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setFullPayment(false)))
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        (!_ctx.isMatch)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_9, [
                          (!_ctx.isMatch)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t("shared_payment")), 1),
                                _createElementVNode("p", _hoisted_12, [
                                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("you_assume_shared_payment")), 1)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.$t("payment")), 1)
                              ])),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("p", {
                              class: "text-lg sm:text-lg",
                              innerHTML: _ctx.sharedPaymentPriceStr
                            }, null, 8, _hoisted_17)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToAddPlayers()))
                        }, [
                          _hoisted_19,
                          (!_ctx.playersMode && !_ctx.isMatch)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t("add_players")), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.playersMode && _ctx.isMatch)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.$t("edit_positions")), 1))
                            : _createCommentVNode("", true),
                          (_ctx.playersMode)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.$t("edit_positions")), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.playersMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      (_ctx.getOwner() !== undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _hoisted_28,
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.getOwner().name), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("span", {
                                innerHTML: _ctx.getPrice(_ctx.getOwner().customerId)
                              }, null, 8, _hoisted_31)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.booking.players.filter(
                  (y) =>
                    y.owner === false &&
                    (!y.hasOwnProperty('paid') || y.paid === false)
                ), (player, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "checkoutPlayers w-full mt-4 p-2"
                        }, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _hoisted_34,
                              _createElementVNode("p", _hoisted_35, _toDisplayString(player.name ? player.name : "Guest Player"), 1)
                            ]),
                            (player.amount && _ctx.isBooked)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(player.amount.amountStr), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFull)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass([{ customBorder: _ctx.fullPayment === true }, "paymentOption cursor-pointer flex md:items-center md:flex-row p-6 justify-between md:mt-8 sm:mt-4 sm:flex-col"]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFullPayment(true)))
                    }, [
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("h2", _hoisted_41, _toDisplayString(_ctx.$t("full_payment")), 1),
                            _createElementVNode("p", _hoisted_42, [
                              _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("you_assume_full_payment")), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", null, [
                              (_ctx.fullPaymentPriceWithoutTaxes)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                    _createElementVNode("p", {
                                      innerHTML: _ctx.Format.addTaxString(_ctx.fullPaymentPriceStr)
                                    }, null, 8, _hoisted_46)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.fullPaymentPriceStr), 1)
                                  ]))
                            ])
                          ])
                        ])
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.showInHOuse)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setFullPayment(true))),
                      class: "customBorder paymentOption cursor-pointer flex md:items-center md:flex-row p-6 justify-between md:mt-8 sm:mt-4 sm:flex-col"
                    }, [
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("div", null, [
                          _createElementVNode("h2", _hoisted_51, _toDisplayString(_ctx.$t("pay_in")) + " " + _toDisplayString(_ctx.capitalizeFirstLetter(_ctx.booking.tenant)), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.payInHouse)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      (_ctx.payWarningMsg != '' && _ctx.payShared)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _hoisted_54,
                            _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.payWarningMsg), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("h2", _hoisted_57, _toDisplayString(_ctx.$t("total")), 1),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("p", {
                            class: "text-2xl sm:text-lg",
                            innerHTML: _ctx.displayedPrice
                          }, null, 8, _hoisted_59)
                        ]),
                        (_ctx.isMatch && !_ctx.fromJoin)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              _createElementVNode("div", {
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToAddPlayers()))
                              }, [
                                _hoisted_61,
                                _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.$t("edit_positions")), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  class: "flex justify-center buttomPayMode md:mt-8 sm:mt-4 mb-8 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.procedToPay()))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("text_continue")), 1)
                ])), [
                  [_directive_disable_on_click, void 0, "proced-to-pay"]
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}